import { IconChevronDown, IconUserScan } from '@tabler/icons-react';
import { Skeleton } from 'antd';
import { useFela } from 'react-fela';

import type { AuthUser } from '@/modules/auth/schemas/oauth';
import { UserAvatar } from '@/modules/ui';

import * as felaRules from './UserIdentity.rules';

interface UserIdentityProps {
    user: AuthUser | null;
    viewingAsOther: boolean;
    displayName: string | undefined;
    open: boolean;
}

export const UserIdentity = ({ user, viewingAsOther, displayName, open }: UserIdentityProps) => {
    const { css } = useFela({ open });

    if (!user && !viewingAsOther) {
        return (
            <>
                <Skeleton.Avatar active size={24} />
                <span className={css(felaRules.nameSkeleton)}>
                    <Skeleton.Node active className={css(felaRules.nameSkeletonNode)} />
                </span>
                <IconChevronDown size={16} className={css(felaRules.chevron)} />
            </>
        );
    }

    return (
        <>
            {viewingAsOther ? (
                <span className={css(felaRules.targetIcon)}>
                    <IconUserScan size={24} />
                </span>
            ) : (
                <UserAvatar name={user?.name ?? ''} pictureUrl={user?.photoUrl} size={24} />
            )}
            <span className={css(felaRules.name)}>{displayName}</span>
            <IconChevronDown size={16} className={css(felaRules.chevron)} />
        </>
    );
};
